import "../../../../../../../../../../chunks/async.js";
import { f as derived } from "../../../../../../../../../../chunks/renderer.js";
import { u as updateDocument, d as deleteDocument } from "../../../../../../../../../../chunks/servers.remote.js";
import { g as goto } from "../../../../../../../../../../chunks/client2.js";
import { b as base } from "../../../../../../../../../../chunks/server.js";
import "../../../../../../../../../../chunks/url.js";
import "@sveltejs/kit/internal/server";
import "../../../../../../../../../../chunks/root.js";
import { P as PrettyJson } from "../../../../../../../../../../chunks/PrettyJson.js";
import { n as notificationStore } from "../../../../../../../../../../chunks/notifications.svelte.js";
function _page($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    let { data } = $$props;
    let loading = false;
    let item = derived(() => data.document);
    async function editDocument(json) {
      const newId = json?._id?.$value ?? json?._id;
      const oldId = item()?._id?.$value ?? item()?._id;
      if (newId !== oldId) {
        notificationStore.notifyError("ObjectId changed. This is not supported, update canceled.");
        return;
      }
      if (!oldId) {
        return;
      }
      loading = true;
      try {
        const result = await updateDocument({
          server: data.server,
          database: data.database,
          collection: data.collection,
          document: oldId,
          value: json,
          partial: false
        });
        if (result.ok) {
          notificationStore.notifySuccess("Document updated successfully");
          item(result.update);
        }
      } catch (error) {
        notificationStore.notifyError(error, "Failed to update document");
      } finally {
        loading = false;
      }
    }
    async function removeDocument() {
      const documentId = item()?._id?.$value ?? item()?._id;
      if (!documentId) {
        return;
      }
      try {
        await deleteDocument({
          server: data.server,
          database: data.database,
          collection: data.collection,
          document: documentId
        });
        notificationStore.notifySuccess("Document removed successfully");
        goto(
          /* eslint-disable-next-line svelte/no-navigation-without-resolve */
          `${base}/servers/${encodeURIComponent(data.server)}/databases/${encodeURIComponent(data.database)}/collections/${encodeURIComponent(data.collection)}?query=${encodeURIComponent("{}")}&sort=&project=&skip=0&limit=20`
        );
      } catch (error) {
        notificationStore.notifyError(error, "Failed to remove document");
      }
    }
    if (loading) {
      $$renderer2.push("<!--[0-->");
      $$renderer2.push(`<div class="loading svelte-khslrq">Loading...</div>`);
    } else if (item()) {
      $$renderer2.push("<!--[1-->");
      PrettyJson($$renderer2, {
        json: item(),
        onedit: data.readOnly ? void 0 : editDocument,
        onremove: data.readOnly ? void 0 : removeDocument,
        server: data.server,
        database: data.database,
        collection: data.collection,
        mappings: data.mappings
      });
    } else {
      $$renderer2.push("<!--[-1-->");
      $$renderer2.push(`<div class="not-found-container svelte-khslrq"><div class="text-center svelte-khslrq">Document not found</div> `);
      if (!data.readOnly) {
        $$renderer2.push("<!--[0-->");
        $$renderer2.push(`<button class="btn btn-success">Insert Document</button>`);
      } else {
        $$renderer2.push("<!--[-1-->");
      }
      $$renderer2.push(`<!--]--></div>`);
    }
    $$renderer2.push(`<!--]-->`);
  });
}
export {
  _page as default
};
